import React from 'react'

import Text from './primitives/Text'

import Pl from '../i/flip_placeholder.svg'

/**
 * Flip card
 */
class Block4 extends React.Component {
    constructor(props) {
        super(props)
        this.state = { flipped: false }
        this.onClick = this.onClick.bind(this)
    }

    onClick() {
        this.setState(prevState => {
            return { flipped: !prevState.flipped }
        })
    }

    // renderImage(src) {
    //     return (
    //         <div className="image_cnt">
    //             <div className="image_align_cnt">
    //                 <img
    //                     className="original reveal"
    //                     // style={{"maxWidth": "none", "height": "100%"}} // contain
    //                     style={{ maxHeight: 'none', width: '100%' }} // cover
    //                     src={src || Pl}
    //                 ></img>
    //             </div>
    //         </div>
    //     )
    // }

    render() {
        const { frontColor, frontSrc, backColor, backSrc, frontText, backText, id, onUpdate } = this.props
        const { flipped } = this.state
        const st = {
            height: `${this.props.height}px`,
        }

        const frontSt = {
            backgroundColor: frontColor,
            backgroundImage: `url(${frontSrc})`,
        }
        if (!frontColor && !frontSrc) {
            // use placeholder
            frontSt.backgroundImage = `url(${Pl})`
        }

        const backSt = {
            backgroundColor: backColor,
            backgroundImage: `url(${backSrc})`,
        }
        if (!backColor && !backSrc) {
            // use placeholder
            backSt.backgroundImage = `url(${Pl})`
        }

        return (
            <div className={`block __${this.props.t}`} style={st}>
                <div className={`flip_inner ${flipped ? '__flipped' : ''}`}>
                    <div className="flip_side" style={frontSt}>
                        {/* {this.renderImage(this.props.frontSrc)} */}
                        {frontText && (
                            <div className="text-area-cnt">
                                <div className="text-area">
                                    <Text id={id} text={frontText} propName={'frontText'} onUpdate={onUpdate}></Text>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="flip_side __back" style={backSt}>
                        {/* {this.renderImage(this.props.backSrc)} */}
                        {backText && (
                            <div className="text-area-cnt">
                                <div className="text-area">
                                    <Text id={id} text={backText} propName={'backText'} onUpdate={onUpdate}></Text>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="flip_switch" onClick={this.onClick}>
                    <p className={!flipped ? 'active' : ''}>Front</p>
                    <p className={flipped ? 'active' : ''}>Back</p>
                </div>
            </div>
        )
    }
}

export default Block4
